import { createContext } from 'react';
import type { Auth } from 'firebase/auth';
import type { Firestore } from 'firebase/firestore';
import type { AI, GenerativeModel } from 'firebase/ai';
import type { FirebaseStorage } from 'firebase/storage';

export const AIContext = createContext<{
    ai: AI;
    geminiFlashModel: GenerativeModel;
    // imagenModel: ImagenModel;
}>(undefined);
export const AuthContext = createContext<Auth>(undefined);
export const DBContext = createContext<Firestore>(undefined);
export const StorageContext = createContext<FirebaseStorage>(undefined);
